var Titans = require('./titans');

var getUA = require('../common/get-ua').internal;

if ('dianping' === getUA().appName){
  Titans.loadAPIs({
    type: 'dp',
    apis: require('./dp/dp')
  })
}

// promisify
(function(){
  var promisify = require('../promisify');
  promisify(Titans);
})();

(function(){
  var logStat = require('../common/log')
  var version = require('../common/version')
  // 统计Titans调用次数
  logStat("titans", version);
})();

module.exports = Titans;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/index.js
// module id = 127
// module chunks = 10 11 12 13 14 15 16 17 18 19